module.exports = __webpack_public_path__ + "static/media/logo-animado.624c9de9.ogv";